import { createElement } from 'react';

import { mapJsonSeatScheme } from './map-json-seat-scheme';
import { registry } from './registry';

export const createJsonComponent = (scheme: any) => {
  const comp = mapJsonSeatScheme(
    // @ts-expect-error ...
    createElement,
    registry,
    scheme
  );

  return comp;
};
